module.exports = __WEBPACK_EXTERNAL_MODULE_bd05__;